import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Brand} from './brand.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  all(): Observable<Array<Brand>> {
    const headers: HttpHeaders = this.authService.getHeaders();
    return this.httpClient.get<Array<Brand>>(`${environment.baseUrl}/brand`, {headers});
  }
}
